if (!window.__MARGALO_CART_PREMIUM_LOADED__) { window.__MARGALO_CART_PREMIUM_LOADED__ = true;
(() => {
  const LIMIT = 6900;
  const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-AT', { style:'currency', currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }).format(cents / 100);
  let busy = false;

  async function getCart(){
    const res = await fetch(ROOT + 'cart.js', { headers:{'Accept':'application/json'} });
    return res.json();
  }

  function progressMarkup(cart, compact=false){
    const remaining = Math.max(0, LIMIT - cart.total_price);
    const pct = Math.min(100, Math.max(0, cart.total_price / LIMIT * 100));
    const reached = remaining <= 0;
    return `<div class="mc-shipping-progress${compact ? ' mc-shipping-progress--drawer' : ''}" data-mc-shipping>
      <div class="mc-shipping-progress__top">
        <div>
          <span class="mc-shipping-progress__eyebrow">FREE SHIPPING OVER €69</span>
          <strong>${reached ? 'Kostenloser Versand freigeschaltet.' : `Nur noch ${money(remaining)} bis gratis Versand.`}</strong>
        </div>
        <span class="mc-shipping-progress__amount">${reached ? '✓' : `${money(remaining)} TO GO`}</span>
      </div>
      <div class="mc-shipping-progress__track" aria-label="Free shipping progress"><i style="width:${pct}%"></i></div>
      <div class="mc-shipping-progress__scale"><span>${money(cart.total_price)}</span><span>€69</span></div>
    </div>`;
  }

  async function recommendationMarkup(cart, compact=false){
    if (!cart.items || !cart.items.length) return '';
    try {
      const id = cart.items[0].product_id;
      const res = await fetch(`${ROOT}recommendations/products.json?product_id=${id}&limit=8&intent=related`);
      const data = await res.json();
      const cartProductIds = new Set(cart.items.map(i => Number(i.product_id)));
      let items = (data.products || []).filter(p => !cartProductIds.has(Number(p.id))).slice(0,3);
      if (!items.length) items = (data.products || []).slice(0,3);
      if (!items.length) return '';
      const cards = items.map(p => {
        const v = (p.variants || []).find(x => x.available) || (p.variants || [])[0];
        if (!v) return '';
        const img = p.featured_image || (p.images && p.images[0]) || '';
        return `<article class="mc-cart-rec">
          <a class="mc-cart-rec__media" href="${p.url || '#'}"><img src="${img}" alt="${(p.title || '').replace(/"/g,'&quot;')}" loading="lazy"></a>
          <div class="mc-cart-rec__body">
            <a href="${p.url || '#'}" class="mc-cart-rec__title">${p.title}</a>
            <span class="mc-cart-rec__price">${money(p.price)}</span>
            <button type="button" class="mc-cart-rec__add" data-mc-add="${v.id}">ADD TO CART</button>
          </div>
        </article>`;
      }).join('');
      return `<section class="mc-cart-recs${compact ? ' mc-cart-recs--drawer' : ''}" data-mc-recs>
        <div class="mc-cart-recs__head"><div><span>COMPLETE THE LOOK</span><small>A few pieces that pair well with your order.</small></div><b>3 PICKS</b></div>
        <div class="mc-cart-recs__grid">${cards}</div>
      </section>`;
    } catch(e){ return ''; }
  }

  async function enhance(){
    if (busy) return; busy = true;
    try {
      const cart = await getCart();
      if (!cart.items || !cart.items.length) return;
      const drawerItems = document.querySelector('.cart-drawer__items');
      if (drawerItems && !drawerItems.querySelector('[data-mc-shipping]')) drawerItems.insertAdjacentHTML('afterbegin', progressMarkup(cart,true));
      if (drawerItems && !drawerItems.querySelector('[data-mc-recs]')) drawerItems.insertAdjacentHTML('beforeend', await recommendationMarkup(cart,true));

      const cartPage = document.querySelector('.cart-page');
      const cartPageItems = cartPage && cartPage.querySelector('.cart-page__items');
      if (cartPage && cartPageItems && !cartPage.querySelector('[data-mc-shipping]')) cartPageItems.insertAdjacentHTML('beforebegin', progressMarkup(cart,false));
      if (cartPage && cartPageItems && !cartPage.querySelector('[data-mc-recs]')) cartPageItems.insertAdjacentHTML('afterend', await recommendationMarkup(cart,false));
    } finally { busy = false; }
  }

  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-mc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;
    btn.disabled = true; const old = btn.textContent; btn.textContent = 'ADDING…';
    try {
      const res = await fetch(ROOT + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({id:Number(btn.dataset.mcAdd), quantity:1})});
      if (!res.ok) throw new Error('add failed');
      btn.textContent = 'ADDED ✓';
      setTimeout(() => location.reload(), 320);
    } catch(err){ btn.disabled=false; btn.textContent=old; }
  });

  const scheduleEnhance = () => {
    clearTimeout(window.__mcCartTimer);
    window.__mcCartTimer = setTimeout(enhance, 150);
  };

  document.addEventListener('DOMContentLoaded', enhance);
  document.addEventListener('cart:update', scheduleEnhance);
  document.addEventListener('cart:updated', scheduleEnhance);
  document.addEventListener('cart:refresh', scheduleEnhance);
})();

}
